import { extends as _extends } from '../../../../_virtual/_rollupPluginBabelHelpers.js';
import { useRef } from 'react';
import Modal from '../../../../modal/index.js';
import { DialogContainer } from '../styled.js';
import { jsx } from 'react/jsx-runtime';
import { Card } from '../../../dataDisplay/Card/Card.js';

var __rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
function Dialog(props) {
  var initialFocusRef = props.initialFocusRef,
    onClose = props.onClose,
    children = props.children,
    _props$size = props.size,
    size = _props$size === void 0 ? 'md' : _props$size,
    ariaLabelledBy = props['aria-labelledby'],
    ariaDescribedBy = props['aria-describedby'],
    _props$animate = props.animate,
    animate = _props$animate === void 0 ? true : _props$animate,
    restProps = __rest(props, ["initialFocusRef", "onClose", "children", "size", 'aria-labelledby', 'aria-describedby', "animate"]);
  var contentRef = useRef(null);
  return /*#__PURE__*/jsx(Modal, {
    initialFocusRef: /* @TODO: actionFocusRef (old API) works, but initialFocusRef doesnt work, it is undefined in Modal `onActivation`  */
    initialFocusRef || contentRef,
    "aria-labelledby": ariaLabelledBy,
    "aria-describedby": ariaDescribedBy,
    onClose: onClose,
    overlay: true,
    children: /*#__PURE__*/jsx(DialogContainer, _extends({
      $size: size,
      $animate: animate
    }, restProps, {
      children: /*#__PURE__*/jsx(Card, {
        ref: contentRef,
        dropShadow: "300",
        children: children
      })
    }))
  });
}

export { Dialog };
